import * as Job from './job.js';

export function initialize(store) {
  Job.initialize(store);
}
